import { render, staticRenderFns } from "./StockImports.vue?vue&type=template&id=994fac98"
import script from "./StockImports.vue?vue&type=script&lang=js"
export * from "./StockImports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports